import { useEffect, useState } from "react"
import { doc, getDoc } from "firebase/firestore"
import { auth, firestore } from "../firebase"
import { isAllowedAdminEmail } from "../utils/adminEmails"

// null while checking, then true/false. Admins are listed in admin/settings.allowedEmails.
export default function useIsAdmin() {
  const [isAdmin, setIsAdmin] = useState(null)
  useEffect(() => auth.onAuthStateChanged((user) => {
    if (!user) {
      setIsAdmin(false)
      return
    }
    getDoc(doc(firestore, "admin", "settings"))
      .then((snap) => setIsAdmin(isAllowedAdminEmail(snap.exists() ? snap.data().allowedEmails : [], user.email)))
      .catch(() => setIsAdmin(isAllowedAdminEmail([], user.email)))
  }), [])
  return isAdmin
}
